export const KEYCLOAK_BASE_ADDRESS=process.env.REACT_APP_KEYCLOAK_BASE_ADDRESS;
export const VIMEO_BASE_ADDRESS=process.env.REACT_APP_VIDEO_SYNC_BASE_ADDRESS;